import PageLayout from './PageLayout';

const h2 = { fontSize: '1.125rem', fontWeight: 600, marginTop: '2rem', marginBottom: '0.5rem' };
const p = { color: '#94a3b8', fontSize: '0.875rem', lineHeight: 1.7, margin: '0.5rem 0' };

export default function TermsPage() {
  return (
    <PageLayout>
      <article style={{ maxWidth: '700px', margin: '0 auto', padding: '3rem 2rem' }}>
        <h1 style={{ fontSize: '1.75rem', fontWeight: 700, marginBottom: '0.5rem' }}>Terms of Use</h1>
        <p style={{ ...p, color: '#64748b' }}>Last updated: May 2026</p>

        <h2 style={h2}>1. Acceptance of Terms</h2>
        <p style={p}>
          By using XposureFlow you agree to these Terms of Use. If you don&rsquo;t agree,
          please don&rsquo;t use the Service.
        </p>

        <h2 style={h2}>2. About the Service</h2>
        <p style={p}>
          XposureFlow is a non-commercial project that provides free access to visualizations
          of publicly available options market data. It is designed to help people explore and
          understand options market structure, dealer positioning, and hedging flows.
        </p>
        <p style={p}>
          XposureFlow is not a trading platform, data vendor, or financial advisory service.
        </p>

        <h2 style={h2}>3. Not Financial Advice</h2>
        <p style={p}>
          Nothing on this platform constitutes investment advice, a trading recommendation,
          or a solicitation to buy or sell any security. All content is provided for
          educational and informational purposes only.
        </p>
        <p style={p}>
          XposureFlow is not a registered investment adviser, broker-dealer, or financial
          institution. You are solely responsible for your own financial decisions. If you
          need investment advice, consult a qualified professional.
        </p>

        <h2 style={h2}>4. Data Accuracy</h2>
        <p style={p}>
          The data shown on XposureFlow is derived from publicly available market sources
          and processed through computational models. It may be delayed, incomplete, or
          contain errors. It should not be relied upon as the sole basis for any financial
          decision.
        </p>

        <h2 style={h2}>5. No Warranty</h2>
        <p style={p}>
          XposureFlow is provided free of charge, &ldquo;as is,&rdquo; and without warranty
          of any kind. There is no guarantee of availability, uptime, accuracy, or
          completeness. The Service may be modified, interrupted, or discontinued at any
          time without notice.
        </p>

        <h2 style={h2}>6. Account Access</h2>
        <p style={p}>
          Access to XposureFlow is free but must be requested. Requests are reviewed at our
          discretion and may be declined or revoked at any time without notice.
        </p>
        <p style={p}>
          If you are given login credentials, please keep them confidential. Do not share
          your credentials or provide access to anyone who has not been separately approved.
        </p>

        <h2 style={h2}>7. Intellectual Property</h2>
        <p style={p}>
          The software, visualizations, and analytical methods used by XposureFlow are
          original work. The underlying market data is sourced from third-party providers.
          Please don&rsquo;t redistribute, scrape, or commercially exploit the Service or
          its output.
        </p>

        <h2 style={h2}>8. Limitation of Liability</h2>
        <p style={p}>
          XposureFlow is an educational resource provided at no cost. In no event shall
          XposureFlow or its contributors be liable for any losses, damages, or costs
          arising from your use of the Service &mdash; including trading losses, data
          inaccuracies, or service interruptions.
        </p>

        <h2 style={h2}>9. Changes to These Terms</h2>
        <p style={p}>
          We may update these terms from time to time. Continued use of the Service after
          changes are posted constitutes acceptance of the revised terms.
        </p>

        <h2 style={h2}>10. Governing Law</h2>
        <p style={p}>
          These terms are governed by applicable law. Any disputes arising from your use
          of the Service will be resolved in accordance with the laws of the jurisdiction
          in which XposureFlow operates.
        </p>
      </article>
    </PageLayout>
  );
}
